import React from "react";
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
class SubTxn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: ''
        }
    }
    render() {

        return (
            <div class={(this.props.txnOrder.status.toLowerCase().includes('success')
                ? 'subtxn-success' :
                this.props.txnOrder.status.toLowerCase().includes('fail')
                    ? 'subtxn-failed' :
                    'subtxn-pending')
            }>
                <div class="row">
                    <div class="col-6 col-md-3 col-lg-3 order-md-1">
                        <div class="subtxt txnsts">{(this.props.txnOrder.status == 'FAILED'
                            || this.props.txnOrder.status == 'INTERNAL_FAILURE'
                            || this.props.txnOrder.status == 'SUCCESS_TO_FAILED'
                            || this.props.txnOrder.status == 'NOT_FOUND'
                        ) ? 'Transaction Failed' :
                            (this.props.txnOrder.status == 'PENDING'
                                || this.props.txnOrder.status == 'ACCEPTED'
                                || this.props.txnOrder.status == 'PROCESSING'
                                || this.props.txnOrder.status == 'HUNG'
                            ) ? 'Sucessfully Processed' :
                                (this.props.txnOrder.status == 'AUTO_REVERSED'
                                    || this.props.txnOrder.status == 'MANUALLY_REVERSED'
                                ) ? 'Transaction Reversed' :
                                    (this.props.txnOrder.status == 'SUCCESS') ? 'Transaction successful' :
                                    this.props.txnOrder.status}

                            </div>
                    </div>

                    <div class="col-6 col-md-2 col-lg-2 order-md-4">
                        <div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.txnOrder.transaction.amount).toFixed(2)}</div>
                    </div>

                    <div class="col-12 col-md-4 col-lg-4 order-md-2">
                        <div class="subtxt subid">Txn ID: {this.props.txnOrder.id}</div>
                    </div>

                    <div class="col-12 col-md-3 col-lg-3 order-md-3">
                        {/* <div class="subtxt">{moment(txRsp.createdOn==null?this.props.createdOn:txRsp.createdOn).format('DD-MM-YYYY hh:mm:ss')}</div> */}
                        <div class="subtxt">{moment(this.props.txnOrder.createdOn).format('DD-MM-YYYY hh:mm:ss')}</div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (
    { errorMessageReduce: { },
        miscReduce: {
        }
    }
) => ({

});

export default connect(mapStateToProps, null)(SubTxn);